import React from 'react'
import WhatsAppIcon from '@material-ui/icons/WhatsApp'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import Box from '@material-ui/core/Box'
import { makeStyles, createStyles, fade } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import { SITE_MATE_DATA } from '../utils/constant'
import ETooltip from '../themes/components/ETooltip'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'fixed',
      right: theme.spacing(3),
      bottom: theme.spacing(12),
      zIndex: theme.zIndex.tooltip,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    whatsAppBtn: {
      backgroundColor: theme.palette.success.main,
      boxShadow: theme.shadows[4],
      '&:hover': {
        backgroundColor: fade(theme.palette.success.main, 0.9),
      },
    },
    FaqBtn: {
      borderRadius: 100,
      width: 130,
      marginBottom: theme.spacing(2),
      backgroundColor: theme.palette.secondary.main,
      color: '#fff',
      boxShadow: theme.shadows[4],
      '&:hover': {
        backgroundColor: fade(theme.palette.secondary.main, 0.9),
      },
    },
    whatsAppIcon: {
      color: theme.palette.primary.contrastText,
    },
    goToTopBtn: {
      backgroundColor: theme.palette.common.white,
      boxShadow: theme.shadows[4],
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.9),
      },
    },
    goToTopIcon: {
      transform: 'rotate(90deg)',
      color: theme.palette.primary.main,
    },
    scrollBtnWrapper: {
      width: theme.spacing(6),
      height: theme.spacing(6),
    },
  }),
)

const GlobalButtons = () => {
  const classes = useStyles()
  const { t, i18n } = useTranslation()
  console.log(i18n.language)
  const handleScrollTop = () =>
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

  return (
    <Box className={classes.root}>
      <Box width="auto">
        <ETooltip placement="left" title="WhatsApp">
          <IconButton
            className={classes.whatsAppBtn}
            aria-label="whatsapp icon"
            href={
              i18n.language === 'zh-HK'
                ? SITE_MATE_DATA.WHATSAPP_PC_HK
                : i18n.language === 'en'
                ? SITE_MATE_DATA.WHATSAPP_PC_EN
                : SITE_MATE_DATA.WHATSAPP_PC_CN
            }
            target="_blank"
          >
            <WhatsAppIcon className={classes.whatsAppIcon} />
          </IconButton>
        </ETooltip>
      </Box>
      <Box mt={2}>
        <ETooltip placement="left" title={t('tips.go_to_top')}>
          <IconButton className={classes.goToTopBtn} aria-label="go to top icon" onClick={handleScrollTop}>
            <ChevronLeftIcon className={classes.goToTopIcon} />
          </IconButton>
        </ETooltip>
      </Box>
    </Box>
  )
}

export default GlobalButtons
